import { render, staticRenderFns } from "./Pushmessage.vue?vue&type=template&id=d07d399a&scoped=true&"
import script from "./Pushmessage.vue?vue&type=script&lang=js&"
export * from "./Pushmessage.vue?vue&type=script&lang=js&"
import style0 from "./Pushmessage.vue?vue&type=style&index=0&id=d07d399a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07d399a",
  null
  
)

export default component.exports